var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-truncate mt-1",staticStyle:{"max-width":"200px","display":"inline-block"}},[_vm._v(_vm._s(_vm.writtenCount > 0 ? _vm.value['en'] : 'No translation'))]),_vm._v(" "),_c('div',{staticClass:"caption grey--text text--darker-1"},[_vm._v(_vm._s(_vm.writtenCount)+" languages written")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1988242e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tables/TranslatableCell.vue
// module id = null
// module chunks = 